import {LOAD_TOW_EMAIL_DATA, LOAD_EMAIL_DATA, DELETE_A_EMAIL, SAVE_A_EMAIL, UPDATE_A_EMAIL,
    SET_EMAIL_EMAIL_ADDRESS_FILTER, SET_EMAIL_ENDTIME_FILTER,
    SET_EMAIL_PLATE_FILTER,
    SET_EMAIL_RECIPIENT_FILTER,
    SET_EMAIL_STARTTIME_FILTER,
    SET_EMAIL_STATUS_FILTER,
    SET_EMAIL_VIN_FILTER,
    SET_CLEAR_ALL_FILTER,CLEAR_A_EMAIL_ERROR_MESSAGE} from './actions';



const initialState = {
    towEmailsArray:[],
    emailsArray:[],
    deleteEmailResp:{},
    errorCMsg:{},
    saveEmailResp:{},
    updateEmailResp:{},
    emailStatusFilter:"",
    emailEmailAddressFilter:"",
    emailVinFilter:"",
    emailPlateFilter:"",
    emailRecipientNameFilter:"",
    emailStartTimeFilter:null,
    emailEndTimeFilter:null,
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_EMAIL_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_TOW_EMAIL_DATA:
          return Object.assign({}, state, {
              towEmailsArray: action.towEmailsData
          });
      case LOAD_EMAIL_DATA:
          return Object.assign({}, state, {
              emailsArray: action.emailsData
          });
      case DELETE_A_EMAIL:
      return Object.assign({}, state, {
          deleteEmailResp: action.deleteEmailResponse,
          errorCMsg: action.errorMsg
      });
      case SAVE_A_EMAIL:
          return Object.assign({}, state, {
              saveEmailResp: action.saveEmailResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_EMAIL:
          return Object.assign({}, state, {
              updateEmailResp: action.updateEmailResponse,
              errorCMsg: action.errorMsg
          });
      case SET_EMAIL_STATUS_FILTER:
          return Object.assign({}, state, {
              emailStatusFilter: action.emailStatusFilter,
          });
      case SET_EMAIL_EMAIL_ADDRESS_FILTER:
          return Object.assign({}, state, {
              emailEmailAddressFilter: action.emailEmailAddressFilter
          });
      case SET_EMAIL_VIN_FILTER:
          return Object.assign({}, state, {
              emailVinFilter: action.emailVinFilter,
          });
      case SET_EMAIL_PLATE_FILTER:
          return Object.assign({}, state, {
              emailPlateFilter: action.emailPlateFilter,
          });
      case SET_EMAIL_RECIPIENT_FILTER:
          return Object.assign({}, state, {
              emailRecipientNameFilter: action.emailRecipientNameFilter,
          });
      case SET_EMAIL_STARTTIME_FILTER:
          return Object.assign({}, state, {
              emailStartTimeFilter: action.emailStartTimeFilter,
          });
      case SET_EMAIL_ENDTIME_FILTER:
          return Object.assign({}, state, {
              emailEndTimeFilter: action.emailEndTimeFilter,
          });
      case SET_CLEAR_ALL_FILTER:
          return Object.assign({}, state, {
              emailStatusFilter:"",
              emailEmailAddressFilter:"",
              emailVinFilter:"",
              emailPlateFilter:"",
              emailRecipientNameFilter:"",
              emailStartTimeFilter:null,
              emailEndTimeFilter:null,
              
          });

    default:
      return state;
  }
}
